import { render } from "./edit-organization.vue?vue&type=template&id=5d755dd2"
import script from "./edit-organization.vue?vue&type=script&lang=js"
export * from "./edit-organization.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__